import React, { useState } from "react";
import LangSelector from "../../elements/LangSelector";

import Accordion from "../../elements/Acordion";
import { Modal } from "react-bootstrap";

import questionLogo from "../../img/question_white.svg";

const HeaderMobile = props => {
  const [openModal, setOpenModal] = useState(false);

  const noImg = name => {
    let sub = name.substring(0, 1);
    return sub.toUpperCase();
  };

  return (
    <div className="header_container_mobile">
      <Modal show={openModal} onHide={() => setOpenModal(false)} centered>
        <Accordion
          bloggerData={props.bloggerData}
          hideModal={setOpenModal}
          width={props.width}
        />
      </Modal>
      <div className="header_mobile">
        <div className="lang_mobile">
          <LangSelector/>
        </div>
        <div className="picture_mobile">
          {props.photoURL !== null ? (
            <div
    className="img_container_mobile"
    style={ { backgroundImage: `url(${ props.photoURL })` } }
    />
          ) : (
            <div
              className="img_container_mobile img_container_mobile_NO_IMG"
              style={{ backgroundColor: "#fff" }}
            >
              <div>{noImg(props.bloggerData.name)}</div>
            </div>
          )}
        </div>
        <div className="questions_mobile">
          <img
            src={questionLogo}
            alt=""
            onClick={() => setOpenModal(!openModal)}
            data-tut="reactour__questions"
          />
        </div>
      </div>

      <p className="blogger_name_mobile">{props.bloggerName}</p>
    </div>
  );
};

export default HeaderMobile;
